export default "__VITE_PUBLIC_ASSET__5c8a2705__"